import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Icon from '../Icon/Icon';
import { setActiveTab } from '../../Reducers/actions/creationsActions';
import { GENRES, GENRE_LABELS, GENRE_ICONS } from '../../constants/genres';
import './FilterBar.scss';

const FilterBar = ({ handleGoBack }) => {
  const dispatch = useDispatch();
  const activeTab = useSelector(state => state.creation.activeTab);

  const tabs = [
    { id: 'all', label: 'All' },
    { id: 'subscriptions', label: 'SUBS' },

    ...Object.values(GENRES).map(genre => ({
      id: genre,
      label: GENRE_LABELS[genre],
      icon: GENRE_ICONS[genre]
    }))
  ];

  const handleTabClick = (tab) => {
    dispatch(setActiveTab(tab));
  };

  return (
    <div className="filter-bar">
      {handleGoBack && <div onClick={handleGoBack}><Icon alias="chevron-left" className={"mr-8 mt-4"} color="#0A0F1E" width={24} height={24} /></div>}
      {tabs.map((category) => (
        <button
          key={category.id}
          className={`filter-item ${activeTab === category.id ? 'active' : ''}`}
          onClick={() => handleTabClick(category.id)}
        >
          {category.icon && (
            <div className="filter-item-icon">
              <Icon
                alias={category.icon}
                width={18}
                height={18}
                color={activeTab === category.id ? '#FFFFFF' : '#282828'}
              />
            </div>
          )}
          {(
            activeTab === category.id ||
            category.label === 'SUBS' ||
            category.label === 'All'
          ) && <span>{category.label}</span>}
        </button>
      ))}
    </div>
  );
};

export default FilterBar;